/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { getEmails } from 'modules/emails/selectors';
import EmailsForm from 'views/forms/emails/index';
import { Link } from 'react-router-dom';
import {
  REPORTS_RECEIVER,
  GLOBAL_REPORTS_RECEIVER,
} from 'utils/email-list-types';

const GeneralSettings = () => {
  const emails = useSelector(getEmails);
  const [initial, setInitial] = useState(null);

  useEffect(() => {
    setInitial({
      keyMetrics:
        emails && emails[REPORTS_RECEIVER]
          ? emails[REPORTS_RECEIVER].join(',')
          : '',
      consolidatedKeyMetrics:
        emails && emails[GLOBAL_REPORTS_RECEIVER]
          ? emails[GLOBAL_REPORTS_RECEIVER].join(',')
          : '',
    });
  }, [emails]);

  return (
    <>
      <Row className="mt-3">
        <Col>
          <div className="location__main__title text-left">
            GENERAL SETTINGS
          </div>
        </Col>
      </Row>
      <Row className="mt-4 d-flex justify-content-center">
        <Col>
          <label className="location__title">ALL STUDIOS REPORTS</label>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col>
          <p className="grey2__text">
            Please enter the list of email recipients who should receive email
            reports for <strong>all studios</strong>. These reports are sent on
            a daily, weekly and monthly basis. <br /> If you only need to add a
            recipient to a specific studio or list of studios, please go to the{' '}
            <Link to="/app/settings/location/">Settings by Location</Link> and
            add the recipient to each applicable Location.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <EmailsForm initialValues={initial} />
        </Col>
      </Row>
    </>
  );
};

export default GeneralSettings;
